<template>
  <v-layout class="text-xs-center blue-grey--text font-weight-light headline">
    <v-fade-transition mode="out-in">
      <!-- A spinner to show when loading the content -->
      <v-flex v-if="loading" key="loading-products">
        <v-pulse-loader :loading="loading" />
      </v-flex>
      <!-- Message to show when there is no active classification nor feature -->
      <v-flex
        v-else-if="!classification || !feature"
        key="no-classification-nor-feaure-set"
      >Selecciona una clasificación y un atributo para ver sus valores</v-flex>
    </v-fade-transition>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VPulseLoader
  },
  data: () => ({
    /* Flags to check if there is anything loading */
    flags: ["loadingClassifications", "loadingFeatures"]
  }),
  computed: {
    ...mapState("valueMapping", ["classification", "feature"]),
    /* Computed property that checks if there is anything loading */
    loading() {
      return this.flags.some(flag => this.$store.state.valueMapping[flag]);
    }
  }
};
</script>